import { render, staticRenderFns } from "./accordionFullWidth.vue?vue&type=template&id=01195af2&"
import script from "./accordionFullWidth.vue?vue&type=script&lang=js&"
export * from "./accordionFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports